import { useStusdsWelcomeDialog } from './logic/useStusdsWelcomeDialog'
import { StusdsWelcomeView } from './views/StusdsWelcomeView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface StusdsWelcomeDialogContainerProps {
  onConfirm: () => void
  chainId: number
}

function StusdsWelcomeDialogContainer({ onConfirm, chainId }: StusdsWelcomeDialogContainerProps) {
  const props = useStusdsWelcomeDialog({ chainId })

  return <StusdsWelcomeView {...props} onConfirm={onConfirm} />
}

const StusdsWelcomeDialogContainerWithSuspense = withSuspense(StusdsWelcomeDialogContainer, DialogContentSkeleton)
export { StusdsWelcomeDialogContainerWithSuspense as StusdsWelcomeDialogContainer }
